import {Platform} from 'react-native';
import {getBottomSpace, isIphoneX} from 'react-native-iphone-screen-helper';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  flex: 1;
  padding: 0 24px;
`;

export const InputGroup = styled.View``;

export const Form = styled.View``;

export const Footer = styled.View`
  padding: 0 24px;
  padding-bottom: ${!isIphoneX() ? RFValue(20) : 0}px;
`;
